import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { ReportFilters, ReportModel } from './report.model';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends AbstractEntityService<ReportModel> {
  constructor(http: HttpClient) {
    super('/api/reports', http);
  }

  preview(filters: ReportFilters & { type: string }): Observable<{ data: { events_count: number } }> {
    return this.http.post<{ data: { events_count: number } }>(`${this.apiUrl}${this.basePath}/preview`, filters);
  }

  createReport(filters: ReportFilters & { type: string }): Observable<ResourceData<ReportModel>> {
    return this.http.post<ResourceData<ReportModel>>(`${this.apiUrl}${this.basePath}`, filters);
  }

  downloadReport(reportId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}${this.basePath}/${reportId}/download`, { responseType: 'blob' });
  }

  deleteReport(reportId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}${this.basePath}/${reportId}`);
  }
}
